<template>
  <v-dialog
    v-model="dialog"
    scrollable
    width="500"
    :transition="false"
    persistent
    content-class="accept-terms"
  >
    <v-card v-if="!showGateway">
      <v-card-title style="padding-left:23px;">
        {{ $t('profile.terms') }}
        <v-spacer />
        <v-btn
          class="justify-self-end"
          icon
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="height: 400px">
        <p
          align="justify"
          v-html="usperson"
        />
        <p
          align="justify"
          v-html="terms"
        />
        <p
          align="justify"
          v-html="risks"
        />
        <p
          align="justify"
          v-html="affs"
        />
      </v-card-text>
      <v-flex
        mt-2
        ml-5
        mb-2
      >
        <v-checkbox
          v-model="acceptTerms"
          color="primary"
        >
          <template v-slot:label>
            <small>
              <b>{{ $t('terms.acceptCheckbox') }}</b>
              <p
                v-if="error !== null"
                class="text-danger"
              >
                <small>{{ error }}</small>
              </p>
            </small>
          </template>
        </v-checkbox>
      </v-flex>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          text
          :disabled="loading"
          :loading="loading"
          @click="go()"
        >
          {{ $t('profile.continueButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title>
        <v-spacer />
        <v-btn
          icon
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="height: 510px">
        <gateways
          :invoice-id="invoiceId"
          @close="close"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Gateways from "@/views/Gateway/partial/Gateways.vue";

export default {
  name: "HelperAcceptTerms",
  components: {
    Gateways
  },
  data: () => ({
    dialog: false,
    acceptTerms: false,
    invoiceId: null,
    showGateway: false,
    error: null,
    loading: false
  }),
  computed: {
     usperson() {
      return this.$t("terms.usPersons").replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    terms() {
      return this.$t("terms.acceptTerms").replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    risks() {
      return this.$t("terms.acceptRisks").replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    affs() {
      return this.$t("terms.acceptAffs").replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
  },
  methods: {
    open() {
      this.error = null;
      this.acceptTerms = false;
      this.dialog = true;
    },
    close() {
      this.invoiceId = null;
      this.showGateway = false;
      this.dialog = false;
    },
    openGateways(invoice_id) {
      this.invoiceId = invoice_id;
      this.showGateway = true;
      this.loading = false;
    },
    go() {
      if (this.acceptTerms === false) {
        this.error = this.$t("profile.pleaseAcceptTerms");
        return;
      }
      this.loading = true;
      this.$emit("acceptTerms");
    }
  }
};
</script>

<style lang="scss">
.accept-terms {
  .v-card__title {
    margin-bottom: 0 !important;
  }
}
</style>
